module.exports = global["$"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/jquery/dist/jquery.js-exposed
// module id = 430
// module chunks = 1